export default {
  AccountMappings: '/groups/:groupId/account-mappings',
  Attachment: '/groups/:groupId/attachments/:attachmentId',
  BatchUpdateOverrideRule: '/groups/:groupId/calculations/:calculationId/matches/_batch',
  ConnectStart: '/connection/start/:groupId',
  ConnectEnd: '/connection/complete',
  ConversionBalances: '/groups/:groupId/conversion-balances',
  Extract: '/extracts/:extractId',
  Group: '/groups/:groupId',
  Groups: '/groups',
  GroupApportionment: '/groups/:groupId/apportionments/:apportionmentId',
  GroupApportionments: '/groups/:groupId/apportionments',
  GroupExchangeRates: '/groups/:groupId/exchange-rates',
  GroupUsers: '/groups/:groupId/users',
  GroupUser: '/groups/:groupId/users/:userId',
  GroupDataTransactionsExtract: '/groups/:groupId/dataTransactions/extract',
  GroupExtract: '/groups/:groupId/extract',
  GroupSources: '/groups/:groupId/sources',
  GroupSubscription: '/groups/:groupId/subscription',
  GroupCalculations: '/groups/:groupId/calculations',
  GroupTrialEndDate: '/groups/:groupId/_trial_end_date',
  Entity: '/groups/:groupId/organisations/:entityId',
  EntityArchive: '/groups/:groupId/organisations/:entityId/_archive',
  EntityContacts: '/groups/:groupId/organisations/:entityId/contacts',
  EntityConnectionStatus: '/groups/:groupId/organisation/:entityId/connection/status',
  EntityRestore: '/groups/:groupId/organisations/:entityId/_restore',
  EntityPosting: '/groups/:groupId/organisations/:entityId/postings/:postingId',
  EntityPostings: '/groups/:groupId/organisations/:entityId/postings',
  UpdateEntity: '/groups/:groupId/organisations/:entityId',
  UpdateEntityGroup: '/groups/:groupId/organisations/:entityId/_update_group',
  MoveEntities: '/groups/:groupId/_move_organisations',
  EntityRules: '/groups/:groupId/organisations/:entityId/rules',
  EntityValues: '/groups/:groupId/organisations/:entityId/values',
  Loan: '/groups/:groupId/loans/:loanId',
  LoanInterest: '/groups/:groupId/loans/:loanId/interest',
  LoanMatches: '/groups/:groupId/loans/:loanId/matches',
  Loans: '/groups/:groupId/loans',
  LoanAccounts: 'groups/:groupId/loan-accounts',
  Notifications: '/groups/:groupId/notifications',
  NotificationsPosting: '/groups/:groupId/notifications/:notificationId/_toggleRead',
  Paylink: '/groups/:groupId/checkout_url',
  Pricing: '/groups/:groupId/pricing',
  ReconciliationLog: '/groups/:groupId/reconciliations',
  Calculation: '/groups/:groupId/calculations/:calculationId',
  CalculationLatestId: '/groups/:groupId/calculations/:calculationId/latest_id',
  CalculationPosting: '/groups/:groupId/calculations/:calculationId/postings/:postingId',
  CalculationPostings: '/groups/:groupId/calculations/:calculationId/postings',
  CalculationLock: '/groups/:groupId/calculations/:calculationId/_lock',
  CalculationUnlock: '/groups/:groupId/calculations/:calculationId/_unlock',
  CalculationRecalculate: '/groups/:groupId/calculations/:calculationId/_recalculate',
  Rule: '/groups/:groupId/rules/:ruleId',
  RuleApportionment: '/groups/:groupId/rule_apportionments/:ruleApptId',
  RuleUpdate: '/groups/:groupId/organisations/:entityId/rules/:ruleId',
  RuleArchive: '/groups/:groupId/organisations/:entityId/rules/:ruleId/_archive',
  RuleRestore: '/groups/:groupId/organisations/:entityId/rules/:ruleId/_restore',
  Sources: '/groups/:groupId/organisations/:entityId/sources',
  TransactionMatch: '/groups/:groupId/calculations/:calculationId/match/:matchId',
  User: '/users/:userId',
  UserGroups: '/users/:userId/groups',
  UserAcceptDocs: '/users/:userId/_accept_docs',
  UnmatchedTransactions: '/groups/:groupId/calculations/:calculationId/organisations/:entityId/unmatched/:type',
  LoginStart: '/user/login',
  LoginEnd: '/user/complete',
  Waitlist: '/waitlist',
};
